<template>
    <div class="dropdown-select">
      <label v-if="label" class="form-label">
        {{ label }}:
      </label>
      <select
        :value="modelValue"
        :class="['form-select w-full', error ? 'border-red-500' : 'border-gray-300']"
        @change="handleChange"
      >
        <option v-for="option in options" :key="option.value" :value="option.value">
          {{ option.text }}
        </option>
      </select>
      <p v-if="error" class="text-red-500 text-xs mt-2">
        {{ error }}
      </p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'StatusDropdown',
    props: {
      modelValue: {
        type: [String, Number, null],
        required: true,
      },
      error: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
    },
    emits: ['update:modelValue', 'change', 'statusText'],
    data() {
      return {
        options: [
          { value: null, text: '' },
          { value: 2, text: 'New' },
          { value: 3, text: '1 Attempt' },
          { value: 4, text: '2 Attempt' },
          { value: 5, text: '3 Attempt' },
          { value: 22, text: '4 Attempt' },
          { value: 23, text: '5 Attempt' },
          { value: 24, text: '6 Attempt' },
          { value: 25, text: '7 Attempt' },
          { value: 26, text: '8 Attempt' },
          { value: 28, text: 'App Complete' },
          { value: 6, text: 'Contacted' },
          { value: 7, text: 'Waiting' },
          { value: 8, text: 'Not Interested' },
          { value: 9, text: 'Not Eligible' },
          { value: 10, text: 'No Response' },
          { value: 11, text: 'Processing' },
          { value: 12, text: 'Closed' },
          { value: 13, text: 'PreApproved' },
          { value: 14, text: 'Do Not Contact' },
          { value: 16, text: 'Credit Repair' },
          { value: 17, text: 'Rate Watch' },
          { value: 19, text: 'Deleted' },
          { value: 20, text: 'Call Back' },
          { value: 21, text: 'Junk' },
        ],
      };
    },
    methods: {
      handleChange(event) {
        const value = event.target.value;
        const text = this.options.find(option => option.value == value)?.text || '';
console.log(text);
        this.$emit('update:modelValue', value);
        this.$emit('change', value);
        this.$emit('statusText', text);
      },
    },
  };
  </script>
  
  <style scoped>
  .form-select {
    padding: 0.5rem;
    border-radius: 0.375rem;
  }
  </style>
  